const selectors = {
  sizeGuideContent: '[data-size-guide-content]',
  unitToggle: '[data-unit-toggle]'
}

const classes = {
  visuallyHidden: 'visually-hidden'
}

class SizeGuideDrawer extends BaseDrawer {
  constructor() {
    const globalSelectors = {
      triggerButton: '[data-size-guide-button]',
      drawer: '[data-size-guide-drawer]',
      overlay: '[data-size-guide-drawer-overlay]',
    };
    super(globalSelectors);
  }

  connectedCallback() {
    this.tableData = this.convertCsvToArrays();
    this.currentUnit = 'CM';
    this.unitToggle = this.querySelector(selectors.unitToggle);

    this.tableHeaders= this.tableData.map((row) => row[0]);

    this.cmColumnIndexes = this.tableHeaders?.reduce((indexes, header, index) => {
      const headerText = String(header || '').toUpperCase();
      if (headerText === 'CM' || headerText.includes(' CM') || headerText.includes('(CM)')) {
        indexes.push(index);
      }
      return indexes;
    }, []);

    this.buildTable();

    // Check if CM columns exist, hide toggle if not
    if (this.cmColumnIndexes.length === 0) {
      this.unitToggle?.parentElement?.classList.add('hidden');
    }

    this.unitToggle?.addEventListener('change', this.toggleUnit.bind(this));
  }

  buildTable() {
    const content = this.querySelector(selectors.sizeGuideContent);
    if (!this.tableData?.length) return;

    const wrapper = document.createElement('div');
    wrapper.innerHTML = `
      <div class="component-size-table__table-wrapper">
        <table class="component-size-table__table">
          ${this.createTableBody(this.tableData)}
        </table>
      </div>
    `;

    content.appendChild(wrapper);
  }

  createTableBody(bodyRows) {
    const headerRow = bodyRows.map((row) => row[0]);
    const dataRows = bodyRows.map(row => row.slice(1));
    const bodyRowsCount = Math.max(...dataRows.map(row => row.length));

    const createTableCell = (value, type = 'data') => {
      return type === 'header' ? `<th>${value}</th>` : `<td>${value}</td>`;
    };

    const createTableBody = () => {
      const tableBodyRows = [];

      for (let i = 0; i < bodyRowsCount; i++) {
        const cells = dataRows.map(row => `<td>${row[i] ?? ''}</td>`).join('');
        tableBodyRows.push(`<tr>${cells}</tr>`);
      }

      return tableBodyRows.join('');
    }

    return `
      <thead>
        <tr>${headerRow.map((header) => createTableCell(header, 'header')).join('')}</tr>
      </thead>
      <tbody>
        ${createTableBody()}
      </tbody>
    `;
  }

  convertCsvToArrays() {
    const content = this.querySelector(selectors.sizeGuideContent);
    if (!content) return [];

    const items = content.dataset.sizeGuideContent;
    if (!items) return [];

    const values = items.replaceAll(', ', ',').split('\n');

    return values.map((row) =>
      row.split(',').map((value) => {
        const numValue = Number(value);
        return numValue ? numValue : value;
      })
    );
  }

  toggleUnit() {
    this.currentUnit = this.currentUnit === 'CM' ? 'IN' : 'CM';

    if (!this.cmColumnIndexes.length) return;

    this.cmColumnIndexes.forEach(colIndex => {
      const cmRow = this.tableData[colIndex];
      const cmValues = cmRow.slice(1);

      const cells = this.querySelectorAll(`tbody tr td:nth-child(${colIndex + 1})`);

      cells.forEach((cell, rowIndex) => {
        const cmValue = cmValues[rowIndex];
        if (typeof cmValue === 'number') {
          const value = this.currentUnit === 'IN'
            ? (cmValue / 2.54).toFixed(1)
            : cmValue;
          cell.textContent = value;
        }
      });

      const header = this.querySelector(`thead th:nth-child(${colIndex + 1})`);
      if (header) {
        const originalHeader = this.tableHeaders[colIndex];
        header.textContent = this.currentUnit === 'IN'
          ? originalHeader.replace(/CM/i, 'IN').replace(/\(CM\)/i, '(IN)')
          : originalHeader;
      }
    });
  }
}

customElements.define('size-guide-drawer', SizeGuideDrawer);